import { FormattedMessage } from 'react-intl';

const Header = () => (
    <div className="display-flex justify-content-center align-items-center gap-5 padding-top-10">
        <span className="text-size-16 text-medium text-color-darkest">
            <FormattedMessage id="intl-msg:vehicle-warnings.title" />
        </span>
        <span
            className={
                `label label-filled label-condensed text-uppercase text-size-10 text-medium ` +
                `bg-warmup-raspberry border-none`
            }
        >
            <FormattedMessage id="intl-msg:vehicle-warnings.preview" />
        </span>
    </div>
);

export default Header;
